var map = {
	"./Amancio Ortega.jpg": 216,
	"./Bernard Arnault.jpg": 217,
	"./Bill Gates.jpg": 218,
	"./Carlos Slim Helu.jpg": 219,
	"./Elon Musk.jpg": 220,
	"./Jeff Bezos.jpg": 221,
	"./Larry Ellison.jpg": 222,
	"./Margot Robbie.jpg": 223,
	"./Mark Zuckerberg.jpg": 224,
	"./Robert Downey Jr..jpg": 225,
	"./Tom Holland.jpg": 226,
	"./Warren Buffett.jpg": 227,
	"./post-img.jpg": 156,
	"./post-img1.jpg": 228,
	"./profile-bg.jpg": 157,
	"./profile-img.jpg": 229,
	"./without avatar.jpg": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;